// https://www.figma.com/design/AlJw9lz2UpBaZjmPJxnYiB/%F0%9F%8C%AA%EF%B8%8F-dark-mode-components?node-id=1606-187897&node-type=CANVAS&t=PherEdXnxYlOYsl0-0

export const peacock = [
  '#1480B81A',
  '#1480B833',
  '#1480B866',
  '#1480B899',
  '#1480B8CC'
]

export const green = [
  '#3BAF6B1A',
  '#3BAF6B33',
  '#3BAF6B66',
  '#3BAF6B99',
  '#3BAF6BCC'
]

export const magenta = [
  '#E184C91A',
  '#E184C933',
  '#E184C966',
  '#E184C999',
  '#E184C9CC'
]

export const aqua = [
  '#40BFBF1A',
  '#40BFBF33',
  '#40BFBF66',
  '#40BFBF99',
  '#40BFBFCC'
]

export const violet = [
  '#948DE21A',
  '#948DE233',
  '#948DE266',
  '#948DE299',
  '#948DE2CC'
]

export const thyme = [
  '#3A78641A',
  '#3A786433',
  '#3A786466',
  '#3A786499',
  '#3A7864CC'
]

export const rosy = [
  '#CA33721A',
  '#CA337233',
  '#CA337266',
  '#CA337299',
  '#CA3372CC'
]

export const airy = [
  '#90B3D51A',
  '#90B3D533',
  '#90B3D566',
  '#90B3D599',
  '#90B3D5CC'
]

export const sky = [
  '#0CA6F21A',
  '#0CA6F233',
  '#0CA6F266',
  '#0CA6F299',
  '#0CA6F2CC'
]

export const purple = [
  '#8A40BF1A',
  '#8A40BF33',
  '#8A40BF66',
  '#8A40BF99',
  '#8A40BFCC'
]

export const mauve = [
  '#9A8FBC1A',
  '#9A8FBC33',
  '#9A8FBC66',
  '#9A8FBC99',
  '#9A8FBCCC'
]

export const blue = [
  '#547ED31A',
  '#547ED333',
  '#547ED366',
  '#547ED399',
  '#547ED3CC'
]

export const mustard = [
  '#99D1611A',
  '#99D16133',
  '#99D16166',
  '#99D16199',
  '#99D161CC'
]

export const navy = [
  '#1833841A',
  '#18338433',
  '#18338466',
  '#18338499',
  '#183384CC'
]

export const chartColors = {
  peacock,
  green,
  magenta,
  aqua,
  violet,
  thyme,
  rosy,
  airy,
  sky,
  purple,
  mauve,
  blue,
  mustard,
  navy
}

export const chartColorsWhell = [
  peacock,
  green,
  magenta,
  aqua,
  violet,
  thyme,
  rosy,
  airy,
  sky,
  purple,
  mauve,
  blue,
  mustard,
  navy
]

// Opaque colors (no alpha channel) for line charts
export const chartColorsOpaque = [
  '#1480B8', // peacock
  '#3BAF6B', // green
  '#E184C9', // magenta
  '#40BFBF', // aqua
  '#948DE2', // violet
  '#3A7864', // thyme
  '#CA3372', // rosy
  '#90B3D5', // airy
  '#0CA6F2', // sky
  '#8A40BF', // purple
  '#9A8FBC', // mauve
  '#547ED3', // blue
  '#99D161', // mustard
  '#183384' // navy
]
